












import { Component, Vue, Mixins } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import { getCsrfWhitelistConfig, setCsrfWhitelistConfig } from '@/apps/open/services/app'
import EditCsrfWhitelistDialogBody from '@/apps/open/components/DialogBodys/app/EditCsrfWhitelistDialogBody.vue'
import { onRequestError } from '@/apps/open/utils'

@Component({
  components: {
    Button
  },
  data: () => ({
    DOMAIN_URL: '#/docs/middle-app/appmgr/access-know'
  })
})
export default class DomainWhitelistSetting extends Vue {
  title = '跨域白名单'
  csrfWhiteList: string[] = []
  submitCount = 0
  submitting = false

  get appId () {
    return this.$route.params.id
  }

  get viewable () {
    return this.csrfWhiteList.length > 0
  }

  get editable () {
    return this.submitCount > 0
  }

  mounted () {
    this.initData()
  }

  async initData () {
    try {
      const res = await getCsrfWhitelistConfig(this.appId)
      if (res.data && res.data.result === 'ok') {
        this.csrfWhiteList = res.data.object.csrf_white_list.split(',')
      }
    } catch (err) {
      onRequestError(err)
    }
  }

  async setCsrfWhitelist () {
    await this.initData()
    this.$dialog.show({
      title: this.title,
      body: EditCsrfWhitelistDialogBody,
      bodyProps: {
        appId: this.appId,
        domainList: this.csrfWhiteList.length ? [...this.csrfWhiteList] : [''],
        submitCount: this.submitCount,
        onCancel: this.$dialog.close,
        onOk: this.submit
      }
    })
  }

  async submit (domainList: string[]) {
    try {
      const res = await setCsrfWhitelistConfig(this.appId, { csrf_white_list: domainList.join(',') })
      if (res.data && res.data.result === 'ok') {
        this.$message.success('跨域白名单保存成功')
      }
    } catch (err) {
      onRequestError(err)
    }
    this.$dialog.close()
  }
}
